


// // import React, { useCallback, useEffect, useMemo, useState } from "react";
// // import axios from "axios";
// // import {
// //   MdAdd, MdRefresh, MdEdit, MdDeleteOutline, MdAcUnit,
// //   MdAirlineSeatReclineExtra, MdCheckCircle, MdWarning,
// //   MdDirectionsBus, MdOutlineChair, MdClose, MdSave,
// // } from "react-icons/md";
// // import "./BusTypes.css";

// // const API_BASE = process.env.REACT_APP_API_URL || "https://bmtvendorvendorfinal.onrender.com/api";
// // const ROWS = 5;
// // const COLS = 15;

// // const emptyGrid = () => Array.from({ length: ROWS * COLS }, (_, i) => ({
// //   row: Math.floor(i / COLS), col: i % COLS, seatNumber: "", isSeat: false,
// //   seatType: "SEATER", category: "REGULAR",
// // }));

// // function preset21() {
// //   const grid = emptyGrid();
// //   ["1", "3", "5", "7", "9", "11"].forEach((n, i) => {
// //     const c = grid.find(x => x.row === 0 && x.col === i);
// //     c.isSeat = true; c.seatNumber = n;
// //   });
// //   ["2", "4", "6", "8", "10", "12"].forEach((n, i) => {
// //     const c = grid.find(x => x.row === 1 && x.col === i);
// //     c.isSeat = true; c.seatNumber = n;
// //   });
// //   return grid;
// // }

// // function preset22() {
// //   const grid = emptyGrid();
// //   let n = 1;
// //   for (let col = 0; col < 10; col++) {
// //     for (const row of [0, 1, 3, 4]) {
// //       const c = grid.find(x => x.row === row && x.col === col);
// //       c.isSeat = true; c.seatNumber = String(n++);
// //     }
// //   }
// //   return grid;
// // }

// // const authHeaders = () => {
// //   const token = localStorage.getItem("vendorToken") || localStorage.getItem("token");
// //   return token ? { Authorization: `Bearer ${token}` } : {};
// // };

// // export default function BusTypes() {
// //   const [mode, setMode] = useState("list");
// //   const [busTypes, setBusTypes] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [saving, setSaving] = useState(false);
// //   const [editingId, setEditingId] = useState(null);
// //   const [toast, setToast] = useState({ text: "", type: "" });
// //   const [name, setName] = useState("Seater/Sleeper 2+1");
// //   const [vehicleMake, setVehicleMake] = useState("Leyland");
// //   const [otherInfo, setOtherInfo] = useState("Air Suspension");
// //   const [seatingType, setSeatingType] = useState("2+1");
// //   const [isAc, setIsAc] = useState(true);
// //   const [hasUpperDeck, setHasUpperDeck] = useState(false);
// //   const [lowerGrid, setLowerGrid] = useState(preset21);
// //   const [upperGrid, setUpperGrid] = useState(emptyGrid);
// //   const [deck, setDeck] = useState("LOWER");
// //   const [categoryModal, setCategoryModal] = useState(false);
// //   const [category, setCategory] = useState("REGULAR");
// //   const [selectedSeats, setSelectedSeats] = useState([]);

// //   const notify = (text, type = "success") => {
// //     setToast({ text, type });
// //     window.setTimeout(() => setToast({ text: "", type: "" }), 3500);
// //   };

// //   const displayName = useMemo(
// //     () => `${vehicleMake} ${name} ${otherInfo} ${isAc ? "AC" : "Non-AC"}`.replace(/\s+/g, " ").trim(),
// //     [vehicleMake, name, otherInfo, isAc]
// //   );
// //   const lowerCount = lowerGrid.filter(s => s.isSeat && s.seatNumber).length;
// //   const upperCount = hasUpperDeck ? upperGrid.filter(s => s.isSeat && s.seatNumber).length : 0;
// //   const totalCount = lowerCount + upperCount;
// //   const activeGrid = deck === "LOWER" ? lowerGrid : upperGrid;

// //   const fetchBusTypes = useCallback(async () => {
// //     setLoading(true);
// //     try {
// //       const res = await axios.get(`${API_BASE}/bus-types/vendor`, { headers: authHeaders() });
// //       const list = res.data?.busTypes || res.data?.data || [];
// //       setBusTypes(Array.isArray(list) ? list : []);
// //     } catch (e) {
// //       setBusTypes([]);
// //       notify(e.response?.data?.message || "Bus types load nahi hue. Backend route check karein.", "error");
// //     } finally {
// //       setLoading(false);
// //     }
// //   }, []);

// //   useEffect(() => { fetchBusTypes(); }, [fetchBusTypes]);

// //   const resetForm = () => {
// //     setEditingId(null); setName("Seater/Sleeper 2+1"); setVehicleMake("Leyland");
// //     setOtherInfo("Air Suspension"); setSeatingType("2+1"); setIsAc(true);
// //     setHasUpperDeck(false); setLowerGrid(preset21()); setUpperGrid(emptyGrid());
// //     setDeck("LOWER"); setSelectedSeats([]);
// //   };

// //   const changeCell = (row, col) => {
// //     const setter = deck === "LOWER" ? setLowerGrid : setUpperGrid;
// //     setter(prev => {
// //       const grid = prev.map(c => ({ ...c }));
// //       const idx = grid.findIndex(c => c.row === row && c.col === col);
// //       if (idx < 0) return prev;
// //       if (grid[idx].isSeat) {
// //         grid[idx].isSeat = false; grid[idx].seatNumber = ""; grid[idx].category = "REGULAR";
// //       } else {
// //         const nums = grid.filter(c => c.isSeat).map(c => Number(c.seatNumber)).filter(Number.isFinite);
// //         grid[idx].isSeat = true;
// //         grid[idx].seatNumber = String(nums.length ? Math.max(...nums) + 1 : (deck === "UPPER" ? lowerCount + 1 : 1));
// //         grid[idx].category = "REGULAR";
// //       }
// //       return grid;
// //     });
// //   };

// //   const applyPreset = type => {
// //     if (type === "2+1") { setSeatingType("2+1"); setLowerGrid(preset21()); }
// //     if (type === "2+2") { setSeatingType("2+2"); setLowerGrid(preset22()); }
// //     if (type === "clear") {
// //       if (deck === "LOWER") setLowerGrid(emptyGrid()); else setUpperGrid(emptyGrid());
// //     }
// //     notify(type === "clear" ? `${deck} deck cleared` : `${type} layout applied`);
// //   };

// //   const autoNumber = () => {
// //     const setter = deck === "LOWER" ? setLowerGrid : setUpperGrid;
// //     setter(prev => {
// //       let number = deck === "LOWER" ? 1 : lowerCount + 1;
// //       return prev.map(c => c.isSeat ? { ...c, seatNumber: String(number++) } : c);
// //     });
// //     notify(`${deck} deck seats numbered`);
// //   };

// //   const applyCategory = () => {
// //     const setter = deck === "LOWER" ? setLowerGrid : setUpperGrid;
// //     setter(prev => prev.map(c => selectedSeats.includes(`${c.row}-${c.col}`) ? { ...c, category } : c));
// //     setCategoryModal(false); setSelectedSeats([]);
// //     notify(`${category} category applied to selected seats`);
// //   };

// //   const save = async () => {
// //     if (!name.trim()) return notify("Bus type name required", "error");
// //     if (!lowerCount && !upperCount) return notify("At least one seat add karein", "error");
// //     setSaving(true);
// //     const payload = {
// //       name, vehicleMake, otherInfo, seatingType, isAc, hasUpperDeck,
// //       gridRows: ROWS, gridCols: COLS, lowerDeckGrid: lowerGrid,
// //       upperDeckGrid: hasUpperDeck ? upperGrid : [],
// //       displayName, totalSeats: totalCount, lowerSeatsCount: lowerCount, upperSeatsCount: upperCount,
// //     };
// //     try {
// //       const res = editingId
// //         ? await axios.put(`${API_BASE}/bus-types/${editingId}`, payload, { headers: authHeaders() })
// //         : await axios.post(`${API_BASE}/bus-types`, payload, { headers: authHeaders() });
// //       if (res.data?.success === false) throw new Error(res.data.message || "Save failed");
// //       notify(editingId ? "Bus type updated successfully" : "Bus type saved successfully");
// //       await fetchBusTypes();
// //       setMode("list"); resetForm();
// //     } catch (e) {
// //       notify(e.response?.data?.message || e.message || "Save failed. Backend endpoint/schema check karein.", "error");
// //     } finally { setSaving(false); }
// //   };

// //   const edit = bt => {
// //     setEditingId(bt._id); setName(bt.name || ""); setVehicleMake(bt.vehicleMake || "Leyland");
// //     setOtherInfo(bt.otherInfo || "Air Suspension"); setSeatingType(bt.seatingType || "2+1");
// //     setIsAc(bt.isAc !== false); setHasUpperDeck(Boolean(bt.hasUpperDeck));
// //     setLowerGrid(bt.lowerDeckGrid?.length ? bt.lowerDeckGrid : preset21());
// //     setUpperGrid(bt.upperDeckGrid?.length ? bt.upperDeckGrid : emptyGrid());
// //     setDeck("LOWER"); setMode("editor");
// //   };

// //   const remove = async id => {
// //     if (!window.confirm("Is bus type ko delete karna hai?")) return;
// //     try {
// //       await axios.delete(`${API_BASE}/bus-types/${id}`, { headers: authHeaders() });
// //       notify("Bus type deleted"); fetchBusTypes();
// //     } catch (e) { notify(e.response?.data?.message || "Delete failed", "error"); }
// //   };

// //   const renderPreview = grid => {
// //     const seats = grid.filter(c => c.isSeat && c.seatNumber);
// //     const maxCol = Math.max(4, ...seats.map(s => s.col));
// //     return <div className="bt-bus-interior">
// //       <div className="bt-driver"><span className="bt-wheel">◎</span><small>DRIVER</small></div>
// //       <div className="bt-preview-seats" style={{ gridTemplateColumns: `repeat(${maxCol + 1}, minmax(20px, 1fr))` }}>
// //         {seats.map(s => <div key={`${s.row}-${s.col}`} className={`bt-mini-seat cat-${(s.category || "REGULAR").toLowerCase()}`} style={{ gridRow: s.row + 1, gridColumn: s.col + 1 }} title={`${s.seatNumber} · ${s.category}`}>
// //           <span>{s.seatNumber}</span>
// //         </div>)}
// //       </div>
// //     </div>;
// //   };

// //   return <main className="bt-page">
// //     {toast.text && <div className={`bt-toast ${toast.type}`}><span>{toast.type === "error" ? <MdWarning /> : <MdCheckCircle />}</span>{toast.text}</div>}
// //     {mode === "list" ? <section className="bt-panel">
// //       <header className="bt-list-header">
// //         <div><div className="bt-eyebrow">FLEET CONFIGURATION</div><h1>Configured Bus Types</h1><p>Registered seating configurations and vehicle blueprints for your fleet.</p></div>
// //         <div className="bt-header-actions"><button className="bt-btn bt-secondary" onClick={fetchBusTypes}><MdRefresh /> Refresh</button><button className="bt-btn bt-primary" onClick={() => { resetForm(); setMode("editor"); }}><MdAdd /> Add New Bus Type</button></div>
// //       </header>
// //       {loading ? <div className="bt-state">Loading bus types…</div> : busTypes.length === 0 ? <div className="bt-empty"><MdAirlineSeatReclineExtra /><h3>No bus types configured</h3><p>Create your first seating layout blueprint.</p><button className="bt-btn bt-primary" onClick={() => { resetForm(); setMode("editor"); }}><MdAdd /> Create Bus Type</button></div> :
// //         <div className="bt-cards">{busTypes.map(bt => <article className="bt-card" key={bt._id}>
// //           <div className="bt-card-heading"><div><h2>{bt.displayName || bt.name}</h2><p>Make: <b>{bt.vehicleMake || "—"}</b> · Layout: <b>{bt.seatingType || "—"}</b></p></div>{bt.isAc && <span className="bt-ac"><MdAcUnit /> AC</span>}</div>
// //           <div className="bt-specs"><div><small>Total capacity</small><b>{bt.totalSeats ?? bt.lowerSeatsCount ?? 0} Seats</b></div><div><small>Lower deck</small><b>{bt.lowerSeatsCount ?? 0}</b></div>{bt.hasUpperDeck && <div><small>Upper deck</small><b>{bt.upperSeatsCount ?? 0}</b></div>}<div><small>Suspension / info</small><b>{bt.otherInfo || "—"}</b></div></div>
// //           <footer className="bt-card-actions"><button className="bt-btn bt-secondary" onClick={() => edit(bt)}><MdEdit /> Edit Layout</button><button className="bt-icon-danger" aria-label="Delete bus type" onClick={() => remove(bt._id)}><MdDeleteOutline /></button></footer>
// //         </article>)}</div>}
// //     </section> : <section className="bt-editor">
// //       <div className="bt-editor-top"><button className="bt-back" onClick={() => { setMode("list"); resetForm(); }}>← Back to Bus Types</button>{editingId && <span className="bt-edit-badge">Editing saved layout</span>}</div>
// //       <div className="bt-editor-title"><div><div className="bt-eyebrow">BUS TYPE BUILDER</div><h1>{editingId ? "Edit Bus Type" : "Create Bus Type"}</h1><p>Configure the vehicle details and click the grid to add or remove seats.</p></div><span className="bt-title-icon"><MdDirectionsBus /></span></div>
// //       <div className="bt-form-grid">
// //         <label className="bt-field bt-field-wide"><span>Name</span><input value={name} onChange={e => setName(e.target.value)} placeholder="e.g. Seater/Sleeper 2+1" /></label>
// //         <label className="bt-field"><span>Vehicle Make</span><select value={vehicleMake} onChange={e => setVehicleMake(e.target.value)}>{["Leyland","Volvo","Scania","Tata","Eicher","BharatBenz","Mercedes-Benz","Force","Isuzu","Other"].map(x => <option key={x}>{x}</option>)}</select></label>
// //         <label className="bt-field"><span>Other info</span><select value={otherInfo} onChange={e => setOtherInfo(e.target.value)}>{["Air Suspension","Non-Air Suspension","Multi-Axle","Ultra Deluxe","Standard","Executive"].map(x => <option key={x}>{x}</option>)}</select></label>
// //         <label className="bt-field"><span>Seating type</span><select value={seatingType} onChange={e => setSeatingType(e.target.value)}>{["2+1","2+2","1+2","2+3","1+1"].map(x => <option key={x}>{x}</option>)}</select></label>
// //         <label className="bt-check"><input type="checkbox" checked={isAc} onChange={e => setIsAc(e.target.checked)} /><span><MdAcUnit /> Air conditioned (AC)</span></label>
// //       </div>
// //       <div className="bt-display-name"><small>BUS TYPE DISPLAY NAME</small><strong>{displayName}</strong></div>
// //       <div className="bt-layout-toolbar">
// //         <div className="bt-deck-tabs"><button className={deck === "LOWER" ? "active" : ""} onClick={() => setDeck("LOWER")}>LOWER <span>{lowerCount} seats</span></button>{hasUpperDeck && <button className={deck === "UPPER" ? "active" : ""} onClick={() => setDeck("UPPER")}>UPPER <span>{upperCount} berths</span></button>}</div>
// //         <label className="bt-upper-toggle"><input type="checkbox" checked={hasUpperDeck} onChange={e => { setHasUpperDeck(e.target.checked); if (!e.target.checked && deck === "UPPER") setDeck("LOWER"); }} /> Include upper deck (sleeper)</label>
// //       </div>
// //       <div className="bt-tools"><div className="bt-tools-label">QUICK LAYOUTS</div><div className="bt-tools-buttons"><button onClick={() => applyPreset("2+1")}>⚡ 2+1 Preset</button><button onClick={() => applyPreset("2+2")}>⚡ 2+2 Preset</button><button onClick={autoNumber}>Auto-number</button><button onClick={() => applyPreset("clear")}>Clear deck</button></div></div>
// //       <div className="bt-layout-columns">
// //         <div className="bt-grid-section"><div className="bt-section-heading"><div><h2>{deck} DECK LAYOUT</h2><p>Click an empty cell to add a seat. Click a seat to remove it.</p></div><span className="bt-seat-count"><MdOutlineChair /> {deck === "LOWER" ? lowerCount : upperCount} seats</span></div>
// //           <div className="bt-matrix-wrap"><div className="bt-matrix" style={{ gridTemplateColumns: `repeat(${COLS}, minmax(28px, 1fr))` }}>{activeGrid.map(cell => <button type="button" key={`${cell.row}-${cell.col}`} className={`bt-cell ${cell.isSeat ? "occupied" : ""} ${selectedSeats.includes(`${cell.row}-${cell.col}`) ? "selected" : ""} cat-${(cell.category || "REGULAR").toLowerCase()}`} onClick={() => categoryModal ? setSelectedSeats(prev => prev.includes(`${cell.row}-${cell.col}`) ? prev.filter(x => x !== `${cell.row}-${cell.col}`) : [...prev, `${cell.row}-${cell.col}`]) : changeCell(cell.row, cell.col)} title={cell.isSeat ? `Seat ${cell.seatNumber} · click to remove` : `Row ${cell.row + 1}, column ${cell.col + 1} · click to add`}>{cell.isSeat ? cell.seatNumber : ""}</button>)}</div></div>
// //           <div className="bt-legend"><span><i className="legend-regular" /> Regular seat</span><span><i className="legend-empty" /> Empty space</span><span><i className="legend-vip" /> Special category</span></div>
// //         </div>
// //         <aside className="bt-preview-section"><div className="bt-section-heading"><div><h2>LIVE BUS PREVIEW</h2><p>Updates as you edit the grid.</p></div><span className="bt-live"><i /> LIVE</span></div><div className="bt-bus-shell">{renderPreview(activeGrid)}</div><div className="bt-preview-summary"><div><small>Total seats</small><strong>{totalCount}</strong></div><div><small>Lower deck</small><strong>{lowerCount}</strong></div><div><small>Upper deck</small><strong>{upperCount}</strong></div></div><button className="bt-category-link" onClick={() => { setSelectedSeats([]); setCategoryModal(true); }}>＋ Categorize seats (optional)</button><p className="bt-category-help">Choose a category, then select seats on the grid.</p></aside>
// //       </div>
// //       <div className="bt-savebar"><div><strong>{totalCount} seats configured</strong><small>{lowerCount} lower{hasUpperDeck ? ` · ${upperCount} upper` : ""} · {isAc ? "AC" : "Non-AC"}</small></div><div><button className="bt-btn bt-secondary" onClick={() => { setMode("list"); resetForm(); }}>Cancel</button><button className="bt-btn bt-primary" disabled={saving} onClick={save}><MdSave /> {saving ? "Saving…" : editingId ? "Update Bus Type" : "Save Bus Type"}</button></div></div>
// //     </section>}
// //     {categoryModal && <div className="bt-modal-backdrop"><section className="bt-modal"><header><div><h2>Categorize seats</h2><p>Select a category, then choose seats in the grid.</p></div><button className="bt-modal-close" onClick={() => { setCategoryModal(false); setSelectedSeats([]); }}><MdClose /></button></header><div className="bt-category-options">{[{id:"REGULAR",label:"Regular seat",desc:"Standard passenger seat"},{id:"LADIES",label:"Ladies quota",desc:"Seats reserved for women"},{id:"SENIOR",label:"Senior citizen",desc:"Priority seating"},{id:"VIP",label:"VIP / Executive",desc:"Premium seating"},{id:"CREW",label:"Crew / Conductor",desc:"Reserved for staff"}].map(c => <label key={c.id} className={category === c.id ? "chosen" : ""}><input type="radio" name="bt-category" checked={category === c.id} onChange={() => setCategory(c.id)} /><span><b>{c.label}</b><small>{c.desc}</small></span></label>)}</div><div className="bt-modal-footer"><span>{selectedSeats.length} seat(s) selected</span><button className="bt-btn bt-secondary" onClick={() => { setCategoryModal(false); setSelectedSeats([]); }}>Cancel</button><button className="bt-btn bt-primary" disabled={!selectedSeats.length} onClick={applyCategory}>Apply category</button></div></section></div>}
// //   </main>;
// // }




// import React, { useCallback, useEffect, useMemo, useState } from "react";
// import axios from "axios";
// import {
//   MdAdd,
//   MdRefresh,
//   MdEdit,
//   MdDeleteOutline,
//   MdAcUnit,
//   MdAirlineSeatReclineExtra,
//   MdCheckCircle,
//   MdWarning,
//   MdDirectionsBus,
//   MdOutlineChair,
//   MdSave,
// } from "react-icons/md";
// import "./BusTypes.css";

// const API_BASE =
//   process.env.REACT_APP_API_URL || "https://bmtvendorvendorfinal.onrender.com/api";

// const ROWS = 7;
// const COLS = 9;

// const TOOLS = [
//   { value: "SEATER", label: "Seater", icon: "▦" },
//   { value: "SLEEPER", label: "Sleeper berth", icon: "▰" },
//   { value: "SEMI_SLEEPER", label: "Semi-sleeper", icon: "▤" },
//   { value: "DRIVER", label: "Driver", icon: "◉" },
//   { value: "CONDUCTOR", label: "Conductor", icon: "●" },
//   { value: "ENTRANCE", label: "Entrance", icon: "↗" },
//   { value: "EXIT", label: "Exit", icon: "↙" },
//   { value: "AISLE", label: "Aisle / Empty", icon: "—" },
// ];

// const CATEGORIES = [
//   { id: "REGULAR", label: "Regular" },
//   { id: "LADIES", label: "Ladies" },
//   { id: "SENIOR", label: "Senior citizen" },
//   { id: "VIP", label: "VIP / Executive" },
//   { id: "CREW", label: "Crew" },
// ];

// const makeGrid = () =>
//   Array.from({ length: ROWS * COLS }, (_, i) => ({
//     row: Math.floor(i / COLS),
//     col: i % COLS,
//     seatNumber: "",
//     isSeat: false,
//     seatType: "SEATER",
//     category: "REGULAR",
//     cellType: "EMPTY",
//     price: 0,
//   }));

// const cellId = (cell) => `${cell.row}-${cell.col}`;

// const presetGrid = (layout = "2+1") => {
//   const grid = makeGrid();
//   let number = 1;

//   const rows = layout === "2+2" ? [0, 1, 3, 4] : [0, 1, 4];
//   const cols = layout === "2+2" ? [1, 2, 5, 6] : [1, 2, 6];

//   rows.forEach((row) => {
//     cols.forEach((col) => {
//       const cell = grid[row * COLS + col];
//       cell.isSeat = true;
//       cell.cellType = "SEAT";
//       cell.seatNumber = String(number++);
//     });
//   });

//   return grid;
// };

// const normalizeGrid = (input) => {
//   const grid = makeGrid();

//   if (!Array.isArray(input)) return grid;

//   input.forEach((item, i) => {
//     const row = Number.isInteger(item.row)
//       ? item.row
//       : Math.floor(i / COLS);

//     const col = Number.isInteger(item.col) ? item.col : i % COLS;

//     if (row < 0 || row >= ROWS || col < 0 || col >= COLS) return;

//     grid[row * COLS + col] = {
//       ...grid[row * COLS + col],
//       ...item,
//       row,
//       col,
//       isSeat: Boolean(item.isSeat),
//       seatType: item.seatType || "SEATER",
//       category: item.category || "REGULAR",
//       cellType: item.cellType || (item.isSeat ? "SEAT" : "EMPTY"),
//     };
//   });

//   return grid;
// };

// const authHeaders = () => {
//   const token =
//     localStorage.getItem("vendorToken") ||
//     localStorage.getItem("token");

//   return token ? { Authorization: `Bearer ${token}` } : {};
// };

// const cellLabel = (cell) => {
//   if (cell.cellType === "DRIVER") return "Driver";
//   if (cell.cellType === "CONDUCTOR") return "Conductor";
//   if (cell.cellType === "ENTRANCE") return "Entrance";
//   if (cell.cellType === "EXIT") return "Exit";
//   if (cell.isSeat) return `Seat ${cell.seatNumber}`;
//   return "Empty space";
// };

// export default function BusTypes() {
//   const [mode, setMode] = useState("list");
//   const [busTypes, setBusTypes] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [editingId, setEditingId] = useState(null);
//   const [toast, setToast] = useState({ text: "", type: "" });

//   const [name, setName] = useState("Seater/Sleeper 2+1");
//   const [vehicleMake, setVehicleMake] = useState("Leyland");
//   const [otherInfo, setOtherInfo] = useState("Air Suspension");
//   const [seatingType, setSeatingType] = useState("2+1");
//   const [isAc, setIsAc] = useState(true);
//   const [hasUpperDeck, setHasUpperDeck] = useState(false);

//   const [lowerGrid, setLowerGrid] = useState(() => presetGrid("2+1"));
//   const [upperGrid, setUpperGrid] = useState(makeGrid);
//   const [deck, setDeck] = useState("LOWER");

//   const [activeTool, setActiveTool] = useState("SEATER");
//   const [category, setCategory] = useState("REGULAR");
//   const [selectedSeats, setSelectedSeats] = useState([]);
//   const [seatPrice, setSeatPrice] = useState("0");

//   const notify = useCallback((text, type = "success") => {
//     setToast({ text, type });
//     window.setTimeout(() => setToast({ text: "", type: "" }), 3200);
//   }, []);

//   const displayName = useMemo(
//     () =>
//       `${vehicleMake} ${name} ${otherInfo} ${
//         isAc ? "AC" : "Non-AC"
//       }`
//         .replace(/\s+/g, " ")
//         .trim(),
//     [vehicleMake, name, otherInfo, isAc]
//   );

//   const lowerCount = lowerGrid.filter(
//     (s) => s.isSeat && s.seatNumber
//   ).length;

//   const upperCount = hasUpperDeck
//     ? upperGrid.filter((s) => s.isSeat && s.seatNumber).length
//     : 0;

//   const totalCount = lowerCount + upperCount;

//   const activeGrid = deck === "LOWER" ? lowerGrid : upperGrid;

//   const setActiveGrid =
//     deck === "LOWER" ? setLowerGrid : setUpperGrid;

//   const fetchBusTypes = useCallback(async () => {
//     setLoading(true);

//     try {
//       const res = await axios.get(
//         `${API_BASE}/bus-types/vendor`,
//         { headers: authHeaders() }
//       );

//       const list = res.data?.busTypes || res.data?.data || [];
//       setBusTypes(Array.isArray(list) ? list : []);
//     } catch (error) {
//       setBusTypes([]);
//       notify(
//         error.response?.data?.message || "Bus types load nahi hue.",
//         "error"
//       );
//     } finally {
//       setLoading(false);
//     }
//   }, [notify]);

//   useEffect(() => {
//     fetchBusTypes();
//   }, [fetchBusTypes]);

//   const resetForm = () => {
//     setEditingId(null);
//     setName("Seater/Sleeper 2+1");
//     setVehicleMake("Leyland");
//     setOtherInfo("Air Suspension");
//     setSeatingType("2+1");
//     setIsAc(true);
//     setHasUpperDeck(false);
//     setLowerGrid(presetGrid("2+1"));
//     setUpperGrid(makeGrid());
//     setDeck("LOWER");
//     setActiveTool("SEATER");
//     setCategory("REGULAR");
//     setSelectedSeats([]);
//     setSeatPrice("0");
//   };

//   const updateCell = (row, col) => {
//     const id = `${row}-${col}`;

//     setActiveGrid((prev) => {
//       const grid = prev.map((cell) => ({ ...cell }));
//       const index = row * COLS + col;
//       const cell = grid[index];

//       if (!cell) return prev;

//       if (activeTool === "AISLE") {
//         grid[index] = {
//           ...cell,
//           isSeat: false,
//           seatNumber: "",
//           cellType: "EMPTY",
//           seatType: "SEATER",
//           category: "REGULAR",
//         };
//       } else if (
//         ["DRIVER", "CONDUCTOR", "ENTRANCE", "EXIT"].includes(activeTool)
//       ) {
//         grid.forEach((item, i) => {
//           if (item.cellType === activeTool) {
//             grid[i] = {
//               ...item,
//               cellType: "EMPTY",
//               isSeat: false,
//               seatNumber: "",
//             };
//           }
//         });

//         grid[index] = {
//           ...cell,
//           isSeat: false,
//           seatNumber: "",
//           cellType: activeTool,
//         };
//       } else if (cell.isSeat && cell.seatType === activeTool) {
//         grid[index] = {
//           ...cell,
//           isSeat: false,
//           seatNumber: "",
//           cellType: "EMPTY",
//         };
//       } else {
//         const used = [...lowerGrid, ...upperGrid]
//           .filter((item) => item.isSeat)
//           .map((item) => Number(item.seatNumber))
//           .filter(Number.isFinite);

//         const nextNumber = used.length
//           ? Math.max(...used) + 1
//           : 1;

//         grid[index] = {
//           ...cell,
//           isSeat: true,
//           cellType: "SEAT",
//           seatNumber: cell.isSeat
//             ? cell.seatNumber
//             : String(nextNumber),
//           seatType: activeTool,
//           category,
//           price: Number(seatPrice) || 0,
//         };
//       }

//       return grid;
//     });

//     setSelectedSeats((prev) => prev.filter((item) => item !== id));
//   };

//   const applyPreset = (type) => {
//     if (type === "2+1" || type === "2+2") {
//       setSeatingType(type);
//       setActiveGrid(presetGrid(type));
//     } else if (type === "clear") {
//       setActiveGrid(makeGrid());
//     }

//     notify(
//       type === "clear"
//         ? `${deck} deck cleared`
//         : `${type} layout applied`
//     );
//   };

//   const autoNumber = () => {
//     let number = deck === "LOWER" ? 1 : lowerCount + 1;

//     setActiveGrid((prev) =>
//       prev.map((cell) =>
//         cell.isSeat
//           ? { ...cell, seatNumber: String(number++) }
//           : cell
//       )
//     );

//     notify(`${deck} deck seats numbered`);
//   };

//   const applyCategory = () => {
//     setActiveGrid((prev) =>
//       prev.map((cell) =>
//         selectedSeats.includes(cellId(cell))
//           ? { ...cell, category }
//           : cell
//       )
//     );

//     setSelectedSeats([]);
//     notify(`${category} category applied`);
//   };

//   const save = async () => {
//     if (!name.trim()) {
//       return notify("Bus type name required", "error");
//     }

//     if (!totalCount) {
//       return notify("At least one passenger seat add karein", "error");
//     }

//     setSaving(true);

//     const payload = {
//       name,
//       vehicleMake,
//       otherInfo,
//       seatingType,
//       isAc,
//       hasUpperDeck,
//       gridRows: ROWS,
//       gridCols: COLS,
//       lowerDeckGrid: lowerGrid,
//       upperDeckGrid: hasUpperDeck ? upperGrid : [],
//       displayName,
//       totalSeats: totalCount,
//       lowerSeatsCount: lowerCount,
//       upperSeatsCount: upperCount,
//     };

//     try {
//       const res = editingId
//         ? await axios.put(
//             `${API_BASE}/bus-types/${editingId}`,
//             payload,
//             { headers: authHeaders() }
//           )
//         : await axios.post(
//             `${API_BASE}/bus-types`,
//             payload,
//             { headers: authHeaders() }
//           );

//       if (res.data?.success === false) {
//         throw new Error(res.data.message || "Save failed");
//       }

//       notify(
//         editingId
//           ? "Bus type updated successfully"
//           : "Bus type saved successfully"
//       );

//       await fetchBusTypes();
//       setMode("list");
//       resetForm();
//     } catch (error) {
//       notify(
//         error.response?.data?.message ||
//           error.message ||
//           "Save failed. Backend schema check karein.",
//         "error"
//       );
//     } finally {
//       setSaving(false);
//     }
//   };

//   const edit = (busType) => {
//     setEditingId(busType._id);
//     setName(busType.name || "");
//     setVehicleMake(busType.vehicleMake || "Leyland");
//     setOtherInfo(busType.otherInfo || "Air Suspension");
//     setSeatingType(busType.seatingType || "2+1");
//     setIsAc(busType.isAc !== false);
//     setHasUpperDeck(Boolean(busType.hasUpperDeck));

//     setLowerGrid(
//       normalizeGrid(
//         busType.lowerDeckGrid?.length
//           ? busType.lowerDeckGrid
//           : presetGrid("2+1")
//       )
//     );

//     setUpperGrid(normalizeGrid(busType.upperDeckGrid || []));
//     setDeck("LOWER");
//     setSelectedSeats([]);
//     setMode("editor");
//   };

//   const remove = async (id) => {
//     if (!window.confirm("Is bus type ko delete karna hai?")) return;

//     try {
//       await axios.delete(`${API_BASE}/bus-types/${id}`, {
//         headers: authHeaders(),
//       });

//       notify("Bus type deleted");
//       fetchBusTypes();
//     } catch (error) {
//       notify(
//         error.response?.data?.message || "Delete failed",
//         "error"
//       );
//     }
//   };

//   const renderBus = (grid) => (
//     <div className="bt-bus-body">
//       <div className="bt-bus-front">
//         <span className="bt-windshield">FRONT WINDSHIELD</span>
//         <span className="bt-front-label">FRONT</span>
//       </div>

//       <div className="bt-bus-interior">
//         <div className="bt-cockpit">
//           <div className="bt-crew-seat driver">
//             ◉<small>DRIVER</small>
//           </div>

//           <div className="bt-steering">◎</div>

//           <div className="bt-crew-seat conductor">
//             ●<small>CONDUCTOR</small>
//           </div>
//         </div>

//         <div
//           className="bt-preview-grid"
//           style={{
//             gridTemplateColumns: `repeat(${COLS}, minmax(0, 1fr))`,
//             gridTemplateRows: `repeat(${ROWS}, minmax(30px, auto))`,
//           }}
//         >
//           {grid.map((cell) => {
//             const special = [
//               "DRIVER",
//               "CONDUCTOR",
//               "ENTRANCE",
//               "EXIT",
//             ].includes(cell.cellType);

//             return (
//               <div
//                 key={cellId(cell)}
//                 className={`bt-preview-cell ${
//                   cell.isSeat
//                     ? `seat ${cell.seatType
//                         .toLowerCase()
//                         .replace("_", "-")}`
//                     : ""
//                 } ${
//                   special
//                     ? `special ${cell.cellType.toLowerCase()}`
//                     : ""
//                 }`}
//                 style={{
//                   gridRow: cell.row + 1,
//                   gridColumn: cell.col + 1,
//                 }}
//                 title={cellLabel(cell)}
//               >
//                 {cell.isSeat && (
//                   <>
//                     <b>{cell.seatNumber}</b>
//                     <small>
//                       {cell.seatType === "SLEEPER"
//                         ? "SL"
//                         : cell.seatType === "SEMI_SLEEPER"
//                         ? "SS"
//                         : "S"}
//                     </small>
//                   </>
//                 )}

//                 {cell.cellType === "ENTRANCE" && (
//                   <span>
//                     ↗<small>ENTRY</small>
//                   </span>
//                 )}

//                 {cell.cellType === "EXIT" && (
//                   <span>
//                     ↙<small>EXIT</small>
//                   </span>
//                 )}
//               </div>
//             );
//           })}
//         </div>

//         <div className="bt-bus-aisle-label">CENTRAL AISLE</div>

//         <div className="bt-bus-rear">
//           <span>REAR</span>
//           <span className="bt-emergency">EMERGENCY EXIT</span>
//         </div>
//       </div>
//     </div>
//   );

//   return (
//     <main className="bt-page">
//       {toast.text && (
//         <div className={`bt-toast ${toast.type}`}>
//           {toast.type === "error" ? <MdWarning /> : <MdCheckCircle />}
//           {toast.text}
//         </div>
//       )}

//       {mode === "list" ? (
//         <section className="bt-panel">
//           <header className="bt-list-header">
//             <div>
//               <div className="bt-eyebrow">FLEET CONFIGURATION</div>
//               <h1>Configured Bus Types</h1>
//               <p>Manage reusable bus layouts for your fleet.</p>
//             </div>

//             <div className="bt-header-actions">
//               <button className="bt-btn bt-secondary" onClick={fetchBusTypes}>
//                 <MdRefresh /> Refresh
//               </button>

//               <button
//                 className="bt-btn bt-primary"
//                 onClick={() => {
//                   resetForm();
//                   setMode("editor");
//                 }}
//               >
//                 <MdAdd /> Add New Bus Type
//               </button>
//             </div>
//           </header>

//           {loading ? (
//             <div className="bt-state">Loading bus types...</div>
//           ) : busTypes.length === 0 ? (
//             <div className="bt-empty">
//               <MdAirlineSeatReclineExtra />
//               <h3>No bus types configured</h3>
//               <p>Create your first bus seating layout.</p>
//               <button
//                 className="bt-btn bt-primary"
//                 onClick={() => {
//                   resetForm();
//                   setMode("editor");
//                 }}
//               >
//                 <MdAdd /> Create Bus Type
//               </button>
//             </div>
//           ) : (
//             <div className="bt-cards">
//               {busTypes.map((bt) => (
//                 <article className="bt-card" key={bt._id}>
//                   <div className="bt-card-heading">
//                     <div>
//                       <h2>{bt.displayName || bt.name}</h2>
//                       <p>
//                         Make: <b>{bt.vehicleMake || "—"}</b> · Layout:{" "}
//                         <b>{bt.seatingType || "—"}</b>
//                       </p>
//                     </div>

//                     {bt.isAc && (
//                       <span className="bt-ac">
//                         <MdAcUnit /> AC
//                       </span>
//                     )}
//                   </div>

//                   <div className="bt-specs">
//                     <div>
//                       <small>Total capacity</small>
//                       <b>{bt.totalSeats ?? 0} Seats</b>
//                     </div>

//                     <div>
//                       <small>Lower deck</small>
//                       <b>{bt.lowerSeatsCount ?? 0}</b>
//                     </div>

//                     {bt.hasUpperDeck && (
//                       <div>
//                         <small>Upper deck</small>
//                         <b>{bt.upperSeatsCount ?? 0}</b>
//                       </div>
//                     )}

//                     <div>
//                       <small>Vehicle info</small>
//                       <b>{bt.otherInfo || "—"}</b>
//                     </div>
//                   </div>

//                   <footer className="bt-card-actions">
//                     <button
//                       className="bt-btn bt-secondary"
//                       onClick={() => edit(bt)}
//                     >
//                       <MdEdit /> Edit Layout
//                     </button>

//                     <button
//                       className="bt-icon-danger"
//                       onClick={() => remove(bt._id)}
//                       aria-label="Delete bus type"
//                     >
//                       <MdDeleteOutline />
//                     </button>
//                   </footer>
//                 </article>
//               ))}
//             </div>
//           )}
//         </section>
//       ) : (
//         <section className="bt-editor">
//           <div className="bt-editor-top">
//             <button
//               className="bt-back"
//               onClick={() => {
//                 setMode("list");
//                 resetForm();
//               }}
//             >
//               ← Back to Bus Types
//             </button>

//             {editingId && (
//               <span className="bt-edit-badge">Editing saved layout</span>
//             )}
//           </div>

//           <div className="bt-editor-title">
//             <div>
//               <div className="bt-eyebrow">BUS TYPE BUILDER</div>
//               <h1>{editingId ? "Edit Bus Type" : "Create Bus Type"}</h1>
//               <p>
//                 Choose a tool, then click a position in the grid.
//                 The preview updates instantly.
//               </p>
//             </div>

//             <span className="bt-title-icon">
//               <MdDirectionsBus />
//             </span>
//           </div>

//           <div className="bt-form-grid">
//             <label className="bt-field bt-field-wide">
//               <span>Bus type name</span>
//               <input
//                 value={name}
//                 onChange={(e) => setName(e.target.value)}
//                 placeholder="e.g. Volvo AC Sleeper 2+1"
//               />
//             </label>

//             <label className="bt-field">
//               <span>Vehicle make</span>
//               <select
//                 value={vehicleMake}
//                 onChange={(e) => setVehicleMake(e.target.value)}
//               >
//                 {[
//                   "Leyland",
//                   "Volvo",
//                   "Scania",
//                   "Tata",
//                   "Eicher",
//                   "BharatBenz",
//                   "Mercedes-Benz",
//                   "Force",
//                   "Isuzu",
//                   "Other",
//                 ].map((x) => (
//                   <option key={x}>{x}</option>
//                 ))}
//               </select>
//             </label>

//             <label className="bt-field">
//               <span>Vehicle info</span>
//               <select
//                 value={otherInfo}
//                 onChange={(e) => setOtherInfo(e.target.value)}
//               >
//                 {[
//                   "Air Suspension",
//                   "Non-Air Suspension",
//                   "Multi-Axle",
//                   "Ultra Deluxe",
//                   "Standard",
//                   "Executive",
//                 ].map((x) => (
//                   <option key={x}>{x}</option>
//                 ))}
//               </select>
//             </label>

//             <label className="bt-field">
//               <span>Seating configuration</span>
//               <select
//                 value={seatingType}
//                 onChange={(e) => setSeatingType(e.target.value)}
//               >
//                 {["2+1", "2+2", "1+2", "1+1", "2+3", "Custom"].map(
//                   (x) => (
//                     <option key={x}>{x}</option>
//                   )
//                 )}
//               </select>
//             </label>

//             <label className="bt-check">
//               <input
//                 type="checkbox"
//                 checked={isAc}
//                 onChange={(e) => setIsAc(e.target.checked)}
//               />
//               <span>
//                 <MdAcUnit /> Air conditioned (AC)
//               </span>
//             </label>
//           </div>

//           <div className="bt-display-name">
//             <small>BUS DISPLAY NAME</small>
//             <strong>{displayName}</strong>
//           </div>

//           <div className="bt-layout-toolbar">
//             <div className="bt-deck-tabs">
//               <button
//                 className={deck === "LOWER" ? "active" : ""}
//                 onClick={() => setDeck("LOWER")}
//               >
//                 Lower deck <span>{lowerCount} seats</span>
//               </button>

//               {hasUpperDeck && (
//                 <button
//                   className={deck === "UPPER" ? "active" : ""}
//                   onClick={() => setDeck("UPPER")}
//                 >
//                   Upper deck <span>{upperCount} seats</span>
//                 </button>
//               )}
//             </div>

//             <label className="bt-upper-toggle">
//               <input
//                 type="checkbox"
//                 checked={hasUpperDeck}
//                 onChange={(e) => {
//                   setHasUpperDeck(e.target.checked);
//                   if (!e.target.checked && deck === "UPPER") {
//                     setDeck("LOWER");
//                   }
//                 }}
//               />
//               Add upper deck
//             </label>
//           </div>

//           <div className="bt-builder-grid">
//             <section className="bt-grid-section">
//               <div className="bt-section-heading">
//                 <div>
//                   <h2>LAYOUT EDITOR</h2>
//                   <p>Select a tool, then click a position in the grid.</p>
//                 </div>

//                 <span className="bt-seat-count">
//                   <MdOutlineChair />{" "}
//                   {deck === "LOWER" ? lowerCount : upperCount} seats
//                 </span>
//               </div>

//               <div className="bt-tool-palette">
//                 {TOOLS.map((tool) => (
//                   <button
//                     type="button"
//                     key={tool.value}
//                     className={activeTool === tool.value ? "active" : ""}
//                     onClick={() => setActiveTool(tool.value)}
//                   >
//                     <span>{tool.icon}</span>
//                     {tool.label}
//                   </button>
//                 ))}
//               </div>

//               <div className="bt-grid-settings">
//                 <label>
//                   Seat category
//                   <select
//                     value={category}
//                     onChange={(e) => setCategory(e.target.value)}
//                   >
//                     {CATEGORIES.map((c) => (
//                       <option key={c.id} value={c.id}>
//                         {c.label}
//                       </option>
//                     ))}
//                   </select>
//                 </label>

//                 <label>
//                   Seat price (₹)
//                   <input
//                     type="number"
//                     min="0"
//                     value={seatPrice}
//                     onChange={(e) => setSeatPrice(e.target.value)}
//                   />
//                 </label>
//               </div>

//               <div className="bt-matrix-wrap">
//                 <div
//                   className="bt-matrix"
//                   style={{
//                     gridTemplateColumns: `repeat(${COLS}, minmax(28px, 1fr))`,
//                   }}
//                 >
//                   {activeGrid.map((cell) => (
//                     <button
//                       type="button"
//                       key={cellId(cell)}
//                       className={`bt-cell ${
//                         cell.isSeat
//                           ? `occupied ${cell.seatType
//                               .toLowerCase()
//                               .replace("_", "-")}`
//                           : ""
//                       } ${
//                         cell.cellType !== "EMPTY" && !cell.isSeat
//                           ? `cell-${cell.cellType.toLowerCase()}`
//                           : ""
//                       }`}
//                       onClick={() => updateCell(cell.row, cell.col)}
//                       title={`${cellLabel(cell)} · row ${
//                         cell.row + 1
//                       }, position ${cell.col + 1}`}
//                     >
//                       {cell.isSeat
//                         ? cell.seatNumber
//                         : cell.cellType === "DRIVER"
//                         ? "D"
//                         : cell.cellType === "CONDUCTOR"
//                         ? "C"
//                         : cell.cellType === "ENTRANCE"
//                         ? "IN"
//                         : cell.cellType === "EXIT"
//                         ? "OUT"
//                         : ""}
//                     </button>
//                   ))}
//                 </div>
//               </div>

//               <div className="bt-legend">
//                 <span><i className="legend-seater" /> Seater</span>
//                 <span><i className="legend-sleeper" /> Sleeper</span>
//                 <span><i className="legend-semi" /> Semi-sleeper</span>
//                 <span><i className="legend-crew" /> Driver / conductor</span>
//                 <span><i className="legend-empty" /> Empty / aisle</span>
//               </div>

//               <div className="bt-tools-buttons">
//                 <button onClick={() => applyPreset("2+1")}>
//                   Apply 2+1 preset
//                 </button>
//                 <button onClick={() => applyPreset("2+2")}>
//                   Apply 2+2 preset
//                 </button>
//                 <button onClick={autoNumber}>Auto-number seats</button>
//                 <button onClick={() => applyPreset("clear")}>
//                   Clear current deck
//                 </button>
//               </div>
//             </section>

//             <aside className="bt-preview-section">
//               <div className="bt-section-heading">
//                 <div>
//                   <h2>LIVE BUS PREVIEW</h2>
//                   <p>Changes appear here instantly.</p>
//                 </div>
//                 <span className="bt-live"><i /> LIVE</span>
//               </div>

//               <div className="bt-preview-canvas">
//                 {renderBus(activeGrid)}
//               </div>

//               <div className="bt-preview-summary">
//                 <div><small>Total seats</small><strong>{totalCount}</strong></div>
//                 <div><small>Lower deck</small><strong>{lowerCount}</strong></div>
//                 <div><small>Upper deck</small><strong>{upperCount}</strong></div>
//               </div>

//               <div className="bt-preview-note">
//                 <b>Current tool:</b>{" "}
//                 {TOOLS.find((t) => t.value === activeTool)?.label}
//                 <br />
//                 <b>Deck:</b> {deck === "LOWER" ? "Lower deck" : "Upper deck"}
//               </div>
//             </aside>
//           </div>

//           <div className="bt-savebar">
//             <div>
//               <strong>{totalCount} passenger seats configured</strong>
//               <small>
//                 {lowerCount} lower
//                 {hasUpperDeck ? ` · ${upperCount} upper` : ""}
//                 {" · "}
//                 {isAc ? "AC" : "Non-AC"}
//               </small>
//             </div>

//             <div>
//               <button
//                 className="bt-btn bt-secondary"
//                 onClick={() => {
//                   setMode("list");
//                   resetForm();
//                 }}
//               >
//                 Cancel
//               </button>

//               <button
//                 className="bt-btn bt-primary"
//                 disabled={saving}
//                 onClick={save}
//               >
//                 <MdSave />
//                 {saving
//                   ? "Saving..."
//                   : editingId
//                   ? "Update Bus Type"
//                   : "Save Bus Type"}
//               </button>
//             </div>
//           </div>
//         </section>
//       )}
//     </main>
//   );
// }
import React, { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import {
  MdRefresh,
  MdEdit,
  MdDeleteOutline,
  MdAcUnit,
  MdAirlineSeatReclineExtra,
  MdCheckCircle,
  MdWarning,
  MdDirectionsBus,
  MdOutlineChair,
  MdSave,
  MdAdd,
  MdSearch,
} from "react-icons/md";
import "./BusTypes.css";

const API_BASE =
  process.env.REACT_APP_API_URL || "https://bmtvendorvendorfinal.onrender.com/api";

/* =========================================================
   CONSTANTS
   Bus is drawn with the FRONT at the top.
   rows = length of bus, columns = width of bus.
========================================================= */
const DEFAULT_ROWS = 12;
const MIN_ROWS = 3;
const MAX_ROWS = 30;
const MIN_COLS = 3;
const MAX_COLS = 15;

// [seats on left, seats on right] – one aisle column between them
const LAYOUTS = {
  "2+1": [2, 1],
  "2+2": [2, 2],
  "1+2": [1, 2],
  "1+1": [1, 1],
  "2+3": [2, 3],
};

const SEAT_TYPES = ["SEATER", "SLEEPER", "SEMI_SLEEPER"];
const SPECIAL_TYPES = ["DRIVER", "CONDUCTOR", "ENTRANCE", "EXIT"];

const TOOLS = [
  { value: "SEATER", label: "Seater", icon: "▦" },
  { value: "SLEEPER", label: "Sleeper berth", icon: "▰" },
  { value: "SEMI_SLEEPER", label: "Semi-sleeper", icon: "▤" },
  { value: "DRIVER", label: "Driver", icon: "◉" },
  { value: "CONDUCTOR", label: "Conductor", icon: "●" },
  { value: "ENTRANCE", label: "Entrance", icon: "↗" },
  { value: "EXIT", label: "Exit", icon: "↙" },
  { value: "AISLE", label: "Eraser (aisle)", icon: "✕" },
];

const CATEGORIES = [
  { id: "REGULAR", label: "Regular" },
  { id: "LADIES", label: "Ladies" },
  { id: "SENIOR", label: "Senior citizen" },
  { id: "VIP", label: "VIP / Executive" },
  { id: "CREW", label: "Crew" },
];

const MAKES = [
  "Leyland",
  "Volvo",
  "Scania",
  "Tata",
  "Eicher",
  "BharatBenz",
  "Mercedes-Benz",
  "Force",
  "Isuzu",
  "Other",
];

const VEHICLE_INFO = [
  "Air Suspension",
  "Non-Air Suspension",
  "Multi-Axle",
  "Ultra Deluxe",
  "Standard",
  "Executive",
];

const rangeOf = (min, max) =>
  Array.from({ length: max - min + 1 }, (_, i) => min + i);

/* =========================================================
   GRID HELPERS
========================================================= */
const clamp = (value, min, max, fallback) => {
  const n = Math.round(Number(value));
  if (!Number.isFinite(n)) return fallback;
  return Math.min(max, Math.max(min, n));
};

const blankCell = (row, col) => ({
  row,
  col,
  isSeat: false,
  seatNumber: "",
  cellType: "EMPTY",
  seatType: "SEATER",
  category: "REGULAR",
  price: 0,
});

const makeGrid = (rows, cols) =>
  Array.from({ length: rows * cols }, (_, i) =>
    blankCell(Math.floor(i / cols), i % cols)
  );

const normalizeGrid = (input, rows, cols) => {
  const grid = makeGrid(rows, cols);
  if (!Array.isArray(input)) return grid;

  input.forEach((item) => {
    if (!item) return;
    const row = Number(item.row);
    const col = Number(item.col);

    if (
      !Number.isInteger(row) ||
      !Number.isInteger(col) ||
      row < 0 ||
      col < 0 ||
      row >= rows ||
      col >= cols
    ) {
      return;
    }

    const isSeat = Boolean(item.isSeat);

    grid[row * cols + col] = {
      row,
      col,
      isSeat,
      cellType: isSeat
        ? "SEAT"
        : SPECIAL_TYPES.includes(item.cellType)
        ? item.cellType
        : "EMPTY",
      seatNumber: isSeat ? String(item.seatNumber ?? "") : "",
      seatType: SEAT_TYPES.includes(item.seatType) ? item.seatType : "SEATER",
      category: CATEGORIES.some((c) => c.id === item.category)
        ? item.category
        : "REGULAR",
      price: Number(item.price) || 0,
    };
  });

  return grid;
};

// Only seats + special markers are sent to the server.
const compactGrid = (grid) =>
  grid.filter((cell) => cell.isSeat || cell.cellType !== "EMPTY");

const buildPreset = ({ layout, rows, deck, seatType, startNumber, price }) => {
  const [left, right] = LAYOUTS[layout];
  const cols = left + 1 + right;
  const grid = makeGrid(rows, cols);

  const seatCols = [
    ...Array.from({ length: left }, (_, i) => i),
    ...Array.from({ length: right }, (_, i) => left + 1 + i),
  ];

  // Lower deck keeps the first row free for driver + entrance
  const firstRow = deck === "LOWER" ? 1 : 0;
  let number = startNumber;

  for (let r = firstRow; r < rows; r += 1) {
    seatCols.forEach((c) => {
      grid[r * cols + c] = {
        ...grid[r * cols + c],
        isSeat: true,
        cellType: "SEAT",
        seatNumber: String(number),
        seatType,
        category: "REGULAR",
        price,
      };
      number += 1;
    });
  }

  if (deck === "LOWER") {
    grid[0] = { ...grid[0], cellType: "DRIVER" };
    grid[cols - 1] = { ...grid[cols - 1], cellType: "ENTRANCE" };
  }

  return { grid, cols };
};

const defaultLayout = () => {
  const { grid, cols } = buildPreset({
    layout: "2+1",
    rows: DEFAULT_ROWS,
    deck: "LOWER",
    seatType: "SEATER",
    startNumber: 1,
    price: 0,
  });

  return {
    rows: DEFAULT_ROWS,
    cols,
    lower: grid,
    upper: makeGrid(DEFAULT_ROWS, cols),
  };
};

/* Starting layout + details taken from the selected bus */
const initFromBus = (bus) => {
  const layout = LAYOUTS[bus.seatLayoutType] ? bus.seatLayoutType : "2+1";
  const sleeper = /sleeper/i.test(bus.busType || "");
  const upper = sleeper && Number(bus.upperSeats) > 0;
  const [l, r] = LAYOUTS[layout];
  const perRow = l + r;
  const target = upper
    ? Number(bus.lowerSeats) || Math.ceil(Number(bus.totalSeats) / 2)
    : Number(bus.totalSeats) || 36;
  const rows = clamp(
    Math.ceil(target / perRow) + 1,
    MIN_ROWS,
    MAX_ROWS,
    DEFAULT_ROWS
  );
  const seatType = sleeper ? "SLEEPER" : "SEATER";
  const price = Number(bus.price) || 0;

  const low = buildPreset({
    layout,
    rows,
    deck: "LOWER",
    seatType,
    startNumber: 1,
    price,
  });
  const lowCount = low.grid.filter((c) => c.isSeat).length;

  const up = upper
    ? buildPreset({
        layout,
        rows,
        deck: "UPPER",
        seatType,
        startNumber: lowCount + 1,
        price,
      })
    : null;

  const model = (bus.busModel || "").toLowerCase();
  const make =
    MAKES.find((m) => m !== "Other" && model.includes(m.toLowerCase())) ||
    "Other";

  return {
    name: `${layout} ${sleeper ? "Sleeper" : "Seater"}`,
    make,
    layout,
    isAc: !/non-ac/i.test(bus.busType || "") && /ac/i.test(bus.busType || ""),
    hasUpper: upper,
    rows,
    cols: low.cols,
    lower: low.grid,
    upper: up ? up.grid : makeGrid(rows, low.cols),
    price,
  };
};

const toolIcon = (value) =>
  TOOLS.find((tool) => tool.value === value)?.icon || "";

const cellLabel = (cell) => {
  if (cell.isSeat) {
    const type = cell.seatType.replace("_", "-").toLowerCase();
    return `Seat ${cell.seatNumber} · ${type} · ₹${cell.price || 0}`;
  }
  if (cell.cellType === "DRIVER") return "Driver";
  if (cell.cellType === "CONDUCTOR") return "Conductor";
  if (cell.cellType === "ENTRANCE") return "Entrance";
  if (cell.cellType === "EXIT") return "Exit";
  return "Empty space";
};

const authHeaders = () => {
  const token =
    localStorage.getItem("vendorToken") || localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const idOf = (value) => (value && value._id ? value._id : value);

/* =========================================================
   COMPONENT
========================================================= */
export default function BusTypes() {
  const [initial] = useState(defaultLayout);

  // "buses" = vendor's bus list (first screen), "editor" = layout builder
  const [mode, setMode] = useState("buses");
  const [buses, setBuses] = useState([]);
  const [busTypes, setBusTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [selectedBus, setSelectedBus] = useState(null);
  const [toast, setToast] = useState({ text: "", type: "" });

  // list filters
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("ALL");

  // details
  const [name, setName] = useState("Seater 2+1");
  const [vehicleMake, setVehicleMake] = useState("Leyland");
  const [otherInfo, setOtherInfo] = useState("Air Suspension");
  const [seatingType, setSeatingType] = useState("2+1");
  const [isAc, setIsAc] = useState(true);
  const [hasUpperDeck, setHasUpperDeck] = useState(false);

  // layout
  const [dims, setDims] = useState({ rows: initial.rows, cols: initial.cols });
  const [lowerGrid, setLowerGrid] = useState(initial.lower);
  const [upperGrid, setUpperGrid] = useState(initial.upper);
  const [deck, setDeck] = useState("LOWER");

  // tools
  const [activeTool, setActiveTool] = useState("SEATER");
  const [category, setCategory] = useState("REGULAR");
  const [seatPrice, setSeatPrice] = useState("0");

  const notify = useCallback((text, type = "success") => {
    setToast({ text, type });
    window.setTimeout(() => setToast({ text: "", type: "" }), 3200);
  }, []);

  const displayName = useMemo(
    () =>
      `${vehicleMake} ${name} ${otherInfo} ${isAc ? "AC" : "Non-AC"}`
        .replace(/\s+/g, " ")
        .trim(),
    [vehicleMake, name, otherInfo, isAc]
  );

  const lowerCount = lowerGrid.filter((c) => c.isSeat).length;
  const upperCount = hasUpperDeck
    ? upperGrid.filter((c) => c.isSeat).length
    : 0;
  const totalCount = lowerCount + upperCount;

  const activeGrid = deck === "LOWER" ? lowerGrid : upperGrid;
  const setActiveGrid = deck === "LOWER" ? setLowerGrid : setUpperGrid;
  const activeCount = deck === "LOWER" ? lowerCount : upperCount;

  // bus _id -> its bus type
  const busTypeByBus = useMemo(() => {
    const map = {};
    busTypes.forEach((bt) => {
      const key = idOf(bt.bus);
      if (key) map[key] = bt;
    });
    return map;
  }, [busTypes]);

  const doneCount = buses.filter((b) => busTypeByBus[b._id]).length;

  const visibleBuses = useMemo(() => {
    const q = search.trim().toLowerCase();
    return buses.filter((b) => {
      const has = Boolean(busTypeByBus[b._id]);
      if (filter === "DONE" && !has) return false;
      if (filter === "PENDING" && has) return false;
      if (!q) return true;
      return [b.busName, b.busNumber, b.fromCity, b.toCity, b.busModel].some(
        (v) => String(v || "").toLowerCase().includes(q)
      );
    });
  }, [buses, busTypeByBus, search, filter]);

  /* ---------- API ---------- */
  const fetchAll = useCallback(async () => {
    setLoading(true);
    try {
      const [busRes, typeRes] = await Promise.all([
        axios.get(`${API_BASE}/buses/vendor`, { headers: authHeaders() }),
        axios.get(`${API_BASE}/bus-types/vendor`, { headers: authHeaders() }),
      ]);

      const busList = busRes.data?.buses || [];
      const typeList = typeRes.data?.busTypes || typeRes.data?.data || [];

      setBuses(Array.isArray(busList) ? busList : []);
      setBusTypes(Array.isArray(typeList) ? typeList : []);
    } catch (error) {
      setBuses([]);
      setBusTypes([]);
      notify(
        error.response?.data?.message ||
          "Could not load buses. Check that the backend is running.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  }, [notify]);

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  /* ---------- form helpers ---------- */
  const resetForm = () => {
    const fresh = defaultLayout();
    setEditingId(null);
    setSelectedBus(null);
    setName("Seater 2+1");
    setVehicleMake("Leyland");
    setOtherInfo("Air Suspension");
    setSeatingType("2+1");
    setIsAc(true);
    setHasUpperDeck(false);
    setDims({ rows: fresh.rows, cols: fresh.cols });
    setLowerGrid(fresh.lower);
    setUpperGrid(fresh.upper);
    setDeck("LOWER");
    setActiveTool("SEATER");
    setCategory("REGULAR");
    setSeatPrice("0");
  };

  const backToList = () => {
    setMode("buses");
    resetForm();
  };

  // Add (no layout yet) -> starts from the bus details
  // Edit (layout exists) -> loads the saved layout
  const openForBus = (bus) => {
    const existing = busTypeByBus[bus._id];
    resetForm();

    if (existing) {
      const rows = clamp(existing.gridRows, MIN_ROWS, MAX_ROWS, DEFAULT_ROWS);
      const cols = clamp(existing.gridCols, MIN_COLS, MAX_COLS, 4);

      setEditingId(existing._id);
      setName(existing.name || "");
      setVehicleMake(existing.vehicleMake || "Leyland");
      setOtherInfo(existing.otherInfo || "Air Suspension");
      setSeatingType(existing.seatingType || "2+1");
      setIsAc(existing.isAc !== false);
      setHasUpperDeck(Boolean(existing.hasUpperDeck));
      setDims({ rows, cols });
      setLowerGrid(normalizeGrid(existing.lowerDeckGrid, rows, cols));
      setUpperGrid(normalizeGrid(existing.upperDeckGrid, rows, cols));
    } else {
      const init = initFromBus(bus);
      setName(init.name);
      setVehicleMake(init.make);
      setSeatingType(init.layout);
      setIsAc(init.isAc);
      setHasUpperDeck(init.hasUpper);
      setDims({ rows: init.rows, cols: init.cols });
      setLowerGrid(init.lower);
      setUpperGrid(init.upper);
      setSeatPrice(String(init.price));
    }

    setSelectedBus(bus);
    setDeck("LOWER");
    setMode("editor");
  };

  const resizeGrid = (rows, cols) => {
    const nextRows = clamp(rows, MIN_ROWS, MAX_ROWS, dims.rows);
    const nextCols = clamp(cols, MIN_COLS, MAX_COLS, dims.cols);
    setDims({ rows: nextRows, cols: nextCols });
    setLowerGrid((prev) => normalizeGrid(prev, nextRows, nextCols));
    setUpperGrid((prev) => normalizeGrid(prev, nextRows, nextCols));
  };

  const renumberDecks = (lower, upper, includeUpper) => {
    let number = 1;
    const apply = (grid) =>
      grid.map((cell) =>
        cell.isSeat ? { ...cell, seatNumber: String(number++) } : cell
      );
    const nextLower = apply(lower);
    const nextUpper = includeUpper ? apply(upper) : upper;
    return [nextLower, nextUpper];
  };

  const nextSeatNumber = () => {
    const used = [...lowerGrid, ...(hasUpperDeck ? upperGrid : [])]
      .filter((cell) => cell.isSeat)
      .map((cell) => Number(cell.seatNumber))
      .filter(Number.isFinite);
    return used.length ? Math.max(...used) + 1 : 1;
  };

  /* ---------- grid actions ---------- */
  const updateCell = (index) => {
    const newNumber = String(nextSeatNumber());
    const price = Number(seatPrice) || 0;

    setActiveGrid((prev) => {
      const grid = prev.map((cell) => ({ ...cell }));
      const cell = grid[index];
      if (!cell) return prev;

      const blank = {
        isSeat: false,
        seatNumber: "",
        cellType: "EMPTY",
        seatType: "SEATER",
        category: "REGULAR",
        price: 0,
      };

      if (activeTool === "AISLE") {
        grid[index] = { ...cell, ...blank };
      } else if (SPECIAL_TYPES.includes(activeTool)) {
        if (cell.cellType === activeTool) {
          grid[index] = { ...cell, ...blank };
        } else {
          grid.forEach((item, i) => {
            if (item.cellType === activeTool) {
              grid[i] = { ...item, ...blank };
            }
          });
          grid[index] = { ...cell, ...blank, cellType: activeTool };
        }
      } else if (cell.isSeat && cell.seatType === activeTool) {
        grid[index] = { ...cell, ...blank };
      } else {
        grid[index] = {
          ...cell,
          isSeat: true,
          cellType: "SEAT",
          seatType: activeTool,
          category,
          price,
          seatNumber: cell.isSeat ? cell.seatNumber : newNumber,
        };
      }

      return grid;
    });
  };

  const applyPreset = (layout) => {
    const seatType = SEAT_TYPES.includes(activeTool) ? activeTool : "SEATER";
    const startNumber = deck === "LOWER" ? 1 : lowerCount + 1;

    const { grid, cols } = buildPreset({
      layout,
      rows: dims.rows,
      deck,
      seatType,
      startNumber,
      price: Number(seatPrice) || 0,
    });

    const otherGrid = normalizeGrid(
      deck === "LOWER" ? upperGrid : lowerGrid,
      dims.rows,
      cols
    );

    const lowerNext = deck === "LOWER" ? grid : otherGrid;
    const upperNext = deck === "UPPER" ? grid : otherGrid;

    const [numberedLower, numberedUpper] = renumberDecks(
      lowerNext,
      upperNext,
      hasUpperDeck
    );

    setDims({ rows: dims.rows, cols });
    setLowerGrid(numberedLower);
    setUpperGrid(numberedUpper);
    setSeatingType(layout);
    notify(`${layout} layout applied to the ${deck.toLowerCase()} deck`);
  };

  const autoNumber = () => {
    const [numberedLower, numberedUpper] = renumberDecks(
      lowerGrid,
      upperGrid,
      hasUpperDeck
    );
    setLowerGrid(numberedLower);
    setUpperGrid(numberedUpper);
    notify("Seats numbered row by row");
  };

  const clearDeck = () => {
    setActiveGrid(makeGrid(dims.rows, dims.cols));
    notify(`${deck === "LOWER" ? "Lower" : "Upper"} deck cleared`);
  };

  const applyToAllSeats = () => {
    const price = Number(seatPrice) || 0;
    setActiveGrid((prev) =>
      prev.map((cell) => (cell.isSeat ? { ...cell, category, price } : cell))
    );
    notify("Category and price applied to every seat on this deck");
  };

  /* ---------- save / delete ---------- */
  const save = async () => {
    if (!selectedBus) return notify("Please select a bus first", "error");
    if (!name.trim()) return notify("Bus type name is required", "error");
    if (!totalCount) {
      return notify("Add at least one passenger seat", "error");
    }

    const numbers = [
      ...lowerGrid.filter((c) => c.isSeat),
      ...(hasUpperDeck ? upperGrid.filter((c) => c.isSeat) : []),
    ].map((c) => c.seatNumber);

    if (new Set(numbers).size !== numbers.length) {
      return notify(
        "Seat numbers must be unique. Use “Auto-number seats” to fix this.",
        "error"
      );
    }

    setSaving(true);

    const payload = {
      bus: selectedBus._id,
      name: name.trim(),
      vehicleMake,
      otherInfo,
      seatingType,
      isAc,
      hasUpperDeck,
      gridRows: dims.rows,
      gridCols: dims.cols,
      lowerDeckGrid: compactGrid(lowerGrid),
      upperDeckGrid: hasUpperDeck ? compactGrid(upperGrid) : [],
    };

    try {
      const res = editingId
        ? await axios.put(`${API_BASE}/bus-types/${editingId}`, payload, {
            headers: authHeaders(),
          })
        : await axios.post(`${API_BASE}/bus-types`, payload, {
            headers: authHeaders(),
          });

      if (res.data?.success === false) {
        throw new Error(res.data.message || "Save failed");
      }

      notify(
        editingId
          ? "Bus type updated successfully"
          : `Bus type saved for ${selectedBus.busNumber}`
      );

      await fetchAll();
      backToList();
    } catch (error) {
      notify(
        error.response?.data?.message ||
          error.message ||
          "Save failed. Please try again.",
        "error"
      );
    } finally {
      setSaving(false);
    }
  };

  const removeLayout = async (bus) => {
    const bt = busTypeByBus[bus._id];
    if (!bt) return;

    if (
      !window.confirm(
        `Delete the bus type / seat layout of ${bus.busNumber}? This cannot be undone.`
      )
    ) {
      return;
    }

    try {
      await axios.delete(`${API_BASE}/bus-types/${bt._id}`, {
        headers: authHeaders(),
      });
      notify("Bus type deleted");
      fetchAll();
    } catch (error) {
      notify(error.response?.data?.message || "Delete failed", "error");
    }
  };

  /* ---------- rendering ---------- */
  const renderCell = (cell, interactive) => {
    const classes = ["bt-cell"];

    if (cell.isSeat) {
      classes.push(
        "seat",
        `seat-${cell.seatType.toLowerCase().replace("_", "-")}`
      );
      if (cell.category !== "REGULAR") {
        classes.push(`cat-${cell.category.toLowerCase()}`);
      }
    } else if (cell.cellType !== "EMPTY") {
      classes.push("marker", `marker-${cell.cellType.toLowerCase()}`);
    }

    if (!interactive) classes.push("static");

    const content = cell.isSeat
      ? cell.seatNumber
      : cell.cellType !== "EMPTY"
      ? toolIcon(cell.cellType)
      : "";

    const shared = { className: classes.join(" "), title: cellLabel(cell) };
    const key = `${cell.row}-${cell.col}`;

    if (interactive) {
      return (
        <button
          key={key}
          type="button"
          {...shared}
          onClick={() => updateCell(cell.row * dims.cols + cell.col)}
        >
          {content}
        </button>
      );
    }

    return (
      <div key={key} {...shared}>
        {content}
      </div>
    );
  };

  const renderGrid = (grid, interactive) => (
    <div
      className="bt-grid"
      style={{
        gridTemplateColumns: `repeat(${dims.cols}, minmax(0, 1fr))`,
        maxWidth: `${Math.max(dims.cols * 54, 220)}px`,
      }}
    >
      {grid.map((cell) => renderCell(cell, interactive))}
    </div>
  );

  const activeToolLabel = TOOLS.find((t) => t.value === activeTool)?.label;
  const seatMismatch =
    selectedBus &&
    Number(selectedBus.totalSeats) > 0 &&
    totalCount !== Number(selectedBus.totalSeats);

  return (
    <main className="bt-page">
      {toast.text && (
        <div className={`bt-toast ${toast.type}`} role="status">
          {toast.type === "error" ? <MdWarning /> : <MdCheckCircle />}
          {toast.text}
        </div>
      )}

      {mode === "buses" ? (
        <section className="bt-panel">
          <header className="bt-list-header">
            <div>
              <h1>Bus types &amp; seat layouts</h1>
              <p>
                Select a bus to add or edit its bus type and seat layout.{" "}
                {buses.length > 0 &&
                  `${doneCount} of ${buses.length} buses configured.`}
              </p>
            </div>

            <div className="bt-header-actions">
              <button
                type="button"
                className="bt-btn bt-secondary"
                onClick={fetchAll}
                disabled={loading}
              >
                <MdRefresh /> Refresh
              </button>
            </div>
          </header>

          {buses.length > 0 && (
            <div className="bt-list-tools">
              <div className="bt-deck-tabs">
                {[
                  { id: "ALL", label: "All", count: buses.length },
                  {
                    id: "PENDING",
                    label: "Layout pending",
                    count: buses.length - doneCount,
                  },
                  { id: "DONE", label: "Configured", count: doneCount },
                ].map((tab) => (
                  <button
                    key={tab.id}
                    type="button"
                    className={filter === tab.id ? "active" : ""}
                    onClick={() => setFilter(tab.id)}
                  >
                    {tab.label} <span>{tab.count}</span>
                  </button>
                ))}
              </div>

              <label className="bt-search">
                <MdSearch />
                <input
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Search bus name, number, city…"
                />
              </label>
            </div>
          )}

          {loading ? (
            <div className="bt-state">Loading buses…</div>
          ) : buses.length === 0 ? (
            <div className="bt-empty">
              <MdDirectionsBus />
              <h3>No buses registered yet</h3>
              <p>
                Register a bus in Buses &amp; Fleet first. Then you can add its
                bus type and seat layout here.
              </p>
            </div>
          ) : visibleBuses.length === 0 ? (
            <div className="bt-state">No buses match your filter.</div>
          ) : (
            <div className="bt-cards">
              {visibleBuses.map((bus) => {
                const bt = busTypeByBus[bus._id];

                return (
                  <article className="bt-card" key={bus._id}>
                    <div className="bt-card-heading">
                      <div>
                        <span className="bt-plate">{bus.busNumber}</span>
                        <h2 style={{ marginTop: 8 }}>{bus.busName}</h2>
                        <p>
                          {bus.fromCity} → {bus.toCity} ·{" "}
                          {bus.busModel || bus.busType}
                        </p>
                      </div>

                      <span className={`bt-badge ${bt ? "done" : "todo"}`}>
                        {bt ? "Layout added" : "Layout pending"}
                      </span>
                    </div>

                    <div className="bt-specs">
                      <div>
                        <small>Bus type</small>
                        <b>{bus.busType || "—"}</b>
                      </div>
                      <div>
                        <small>Seats on bus</small>
                        <b>{bus.totalSeats ?? 0}</b>
                      </div>
                      <div>
                        <small>Layout name</small>
                        <b>{bt ? bt.displayName || bt.name : "Not created"}</b>
                      </div>
                      <div>
                        <small>Seats in layout</small>
                        <b>{bt ? bt.totalSeats : "—"}</b>
                      </div>
                    </div>

                    <footer className="bt-card-actions">
                      <button
                        type="button"
                        className="bt-btn bt-primary"
                        onClick={() => openForBus(bus)}
                      >
                        {bt ? (
                          <>
                            <MdEdit /> Edit layout
                          </>
                        ) : (
                          <>
                            <MdAdd /> Add bus type
                          </>
                        )}
                      </button>
                      {bt && (
                        <button
                          type="button"
                          className="bt-icon-danger"
                          onClick={() => removeLayout(bus)}
                          aria-label="Delete bus type"
                        >
                          <MdDeleteOutline />
                        </button>
                      )}
                    </footer>
                  </article>
                );
              })}
            </div>
          )}
        </section>
      ) : (
        <section className="bt-editor">
          <div className="bt-editor-top">
            <button type="button" className="bt-back" onClick={backToList}>
              ← Back to buses
            </button>
            {editingId && (
              <span className="bt-edit-badge">Editing saved layout</span>
            )}
          </div>

          {selectedBus && (
            <div className="bt-bus-banner">
              <span className="bt-title-icon">
                <MdDirectionsBus />
              </span>
              <div>
                <small>Creating bus type for</small>
                <div className="bt-banner-title">
                  <span className="bt-plate">{selectedBus.busNumber}</span>
                  <strong>{selectedBus.busName}</strong>
                </div>
                <small>
                  {selectedBus.fromCity} → {selectedBus.toCity} ·{" "}
                  {selectedBus.busType} · {selectedBus.totalSeats} seats
                  registered
                </small>
              </div>
            </div>
          )}

          <div className="bt-editor-title">
            <div>
              <h1>{editingId ? "Edit bus type" : "Create bus type"}</h1>
              <p>
                Pick a tool, then click the grid. The bus preview updates as
                you go.
              </p>
            </div>
          </div>

          <div className="bt-form-grid">
            <label className="bt-field bt-field-wide">
              <span>Bus type name</span>
              <input
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="e.g. Sleeper 2+1"
              />
            </label>

            <label className="bt-field">
              <span>Vehicle make</span>
              <select
                value={vehicleMake}
                onChange={(e) => setVehicleMake(e.target.value)}
              >
                {MAKES.map((x) => (
                  <option key={x}>{x}</option>
                ))}
              </select>
            </label>

            <label className="bt-field">
              <span>Vehicle info</span>
              <select
                value={otherInfo}
                onChange={(e) => setOtherInfo(e.target.value)}
              >
                {VEHICLE_INFO.map((x) => (
                  <option key={x}>{x}</option>
                ))}
              </select>
            </label>

            <label className="bt-field">
              <span>Seating configuration</span>
              <select
                value={seatingType}
                onChange={(e) => setSeatingType(e.target.value)}
              >
                {[...Object.keys(LAYOUTS), "Custom"].map((x) => (
                  <option key={x}>{x}</option>
                ))}
              </select>
            </label>

            <label className="bt-check">
              <input
                type="checkbox"
                checked={isAc}
                onChange={(e) => setIsAc(e.target.checked)}
              />
              <span>
                <MdAcUnit /> Air conditioned (AC)
              </span>
            </label>
          </div>

          <div className="bt-display-name">
            <small>Display name</small>
            <strong>{displayName}</strong>
          </div>

          <div className="bt-layout-toolbar">
            <div className="bt-deck-tabs">
              <button
                type="button"
                className={deck === "LOWER" ? "active" : ""}
                onClick={() => setDeck("LOWER")}
              >
                Lower deck <span>{lowerCount} seats</span>
              </button>

              {hasUpperDeck && (
                <button
                  type="button"
                  className={deck === "UPPER" ? "active" : ""}
                  onClick={() => setDeck("UPPER")}
                >
                  Upper deck <span>{upperCount} seats</span>
                </button>
              )}
            </div>

            <label className="bt-upper-toggle">
              <input
                type="checkbox"
                checked={hasUpperDeck}
                onChange={(e) => {
                  setHasUpperDeck(e.target.checked);
                  if (!e.target.checked && deck === "UPPER") setDeck("LOWER");
                }}
              />
              Add upper deck
            </label>
          </div>

          <div className="bt-builder-grid">
            <section className="bt-grid-section">
              <div className="bt-section-heading">
                <div>
                  <h2>Layout editor</h2>
                  <p>
                    Click a cell to place the selected item. Click a seat again
                    with the same tool to remove it.
                  </p>
                </div>
                <span className="bt-seat-count">
                  <MdOutlineChair /> {activeCount} seats
                </span>
              </div>

              <div className="bt-tool-palette">
                {TOOLS.map((tool) => (
                  <button
                    type="button"
                    key={tool.value}
                    className={activeTool === tool.value ? "active" : ""}
                    onClick={() => setActiveTool(tool.value)}
                  >
                    <span>{tool.icon}</span>
                    {tool.label}
                  </button>
                ))}
              </div>

              <div className="bt-grid-settings">
                <label>
                  Seat category
                  <select
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                  >
                    {CATEGORIES.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.label}
                      </option>
                    ))}
                  </select>
                </label>

                <label>
                  Seat price (₹)
                  <input
                    type="number"
                    min="0"
                    value={seatPrice}
                    onChange={(e) => setSeatPrice(e.target.value)}
                  />
                </label>

                <label>
                  Rows (bus length)
                  <select
                    value={dims.rows}
                    onChange={(e) => resizeGrid(e.target.value, dims.cols)}
                  >
                    {rangeOf(MIN_ROWS, MAX_ROWS).map((n) => (
                      <option key={n} value={n}>
                        {n}
                      </option>
                    ))}
                  </select>
                </label>

                <label>
                  Columns (bus width)
                  <select
                    value={dims.cols}
                    onChange={(e) => resizeGrid(dims.rows, e.target.value)}
                  >
                    {rangeOf(MIN_COLS, MAX_COLS).map((n) => (
                      <option key={n} value={n}>
                        {n}
                      </option>
                    ))}
                  </select>
                </label>
              </div>

              <div className="bt-matrix-wrap">
                <div className="bt-front-tag">Front of bus</div>
                {renderGrid(activeGrid, true)}
                <div className="bt-front-tag">Rear of bus</div>
              </div>

              <div className="bt-legend">
                <span>
                  <i className="legend-seater" /> Seater
                </span>
                <span>
                  <i className="legend-sleeper" /> Sleeper
                </span>
                <span>
                  <i className="legend-semi" /> Semi-sleeper
                </span>
                <span>
                  <i className="legend-crew" /> Driver / conductor
                </span>
                <span>
                  <i className="legend-door" /> Entrance / exit
                </span>
              </div>

              <div className="bt-tools-buttons">
                {Object.keys(LAYOUTS).map((layout) => (
                  <button
                    type="button"
                    key={layout}
                    onClick={() => applyPreset(layout)}
                  >
                    Apply {layout}
                  </button>
                ))}
                <button type="button" onClick={autoNumber}>
                  Auto-number seats
                </button>
                <button type="button" onClick={applyToAllSeats}>
                  Apply category and price to all seats
                </button>
                <button type="button" onClick={clearDeck}>
                  Clear this deck
                </button>
              </div>
            </section>

            <aside className="bt-preview-section">
              <div className="bt-section-heading">
                <div>
                  <h2>Bus preview</h2>
                  <p>Showing the {deck === "LOWER" ? "lower" : "upper"} deck.</p>
                </div>
                <span className="bt-live">
                  <i /> Live
                </span>
              </div>

              <div className="bt-preview-canvas">
                <div className="bt-bus">
                  <div className="bt-bus-front">Front</div>
                  {renderGrid(activeGrid, false)}
                  <div className="bt-bus-rear">Rear</div>
                </div>
              </div>

              <div className="bt-preview-summary">
                <div>
                  <small>Total seats</small>
                  <strong>{totalCount}</strong>
                </div>
                <div>
                  <small>Lower deck</small>
                  <strong>{lowerCount}</strong>
                </div>
                <div>
                  <small>Upper deck</small>
                  <strong>{upperCount}</strong>
                </div>
              </div>

              {seatMismatch && (
                <div className="bt-warn">
                  <MdWarning /> This bus is registered with{" "}
                  <b>{selectedBus.totalSeats}</b> seats but the layout has{" "}
                  <b>{totalCount}</b>. You can still save, or adjust the grid.
                </div>
              )}

              <div className="bt-preview-note">
                <b>Current tool:</b> {activeToolLabel}
                <br />
                <b>Grid:</b> {dims.rows} rows × {dims.cols} columns
              </div>
            </aside>
          </div>

          <div className="bt-savebar">
            <div>
              <strong>
                {selectedBus?.busNumber} · {totalCount} passenger seats
              </strong>
              <small>
                {lowerCount} lower
                {hasUpperDeck ? ` · ${upperCount} upper` : ""} ·{" "}
                {isAc ? "AC" : "Non-AC"}
              </small>
            </div>

            <div className="bt-savebar-actions">
              <button
                type="button"
                className="bt-btn bt-secondary"
                onClick={backToList}
              >
                Cancel
              </button>
              <button
                type="button"
                className="bt-btn bt-primary"
                disabled={saving}
                onClick={save}
              >
                <MdSave />
                {saving
                  ? "Saving…"
                  : editingId
                  ? "Update bus type"
                  : "Save bus type"}
              </button>
            </div>
          </div>
        </section>
      )}
    </main>
  );
}